import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table-all.min.css";

const options = {
  sortIndicator: true,
  paginationSize: 3,
  clearSearch: true,
  alwaysShowAllBtns: true,
  withFirstAndLast: true,
  searchFieldStyle: { fontSize: "10px", height: "30px" },
};

export default function ReceivePaymentBody({ data }) {
  const renderTableHeaderColumn = (dataField, headerText, options = {}) => {
    const { filter = true, dataFormat, editable = false, thStyle = {}, tdStyle = {} } = options;
    return (
      <TableHeaderColumn
        dataField={dataField}
        filter={filter ? { type: "TextFilter", delay: 1000 } : undefined}
        dataSort
        tdStyle={{ whiteSpace: "normal", ...tdStyle }} // Apply custom td styles
        thStyle={{
          whiteSpace: "nowrap", // Ensure single-line headings
          backgroundColor: "#f8f9fa",
          fontWeight: "bold",
          textAlign: "center",
          ...thStyle, // Apply custom th styles
        }}
        dataFormat={dataFormat}
        editable={editable}
      >
        {headerText}
      </TableHeaderColumn>
    );
  };

  return (
    <div style={{ fontSize: "12px" }}> {/* Reduced overall font size */}
      <BootstrapTable
        data={data}
        version="4"
        condensed
        striped
        hover
        pagination
        search
        options={options}
        exportCSV
        csvFileName="receive_payment.csv"
      >
        <TableHeaderColumn isKey dataField="id" hidden>
          ID
        </TableHeaderColumn>
        {renderTableHeaderColumn("invoiceNumber", "Invoice No.", {
          thStyle: { fontSize: "12px" }, // Set font size for header
          tdStyle: { fontSize: "11px" }, // Set font size for data
        })}
        {renderTableHeaderColumn("billDate", "Bill Date", {
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("paymentDate", "Payment Date", {
          dataFormat: (cell) => cell.substring(0, 10),
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("amountPaid", "Amount Paid", {
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("remainingBalance", "Balance", {
          editable: true,
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("paymentType", "Payment Type", {
          thStyle: { fontSize: "10px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("referenceNumber", "Ref No.", {
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("chequeNumber", "Cheque No.", {
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("chequeDate", "Cheque Date", {
          thStyle: { fontSize: "12px" },
          tdStyle: { fontSize: "11px" },
        })}
        {renderTableHeaderColumn("chequeStatus", "Cheque Status", {
          thStyle: { fontSize: "10px" },
          tdStyle: { fontSize: "11px" },
        })}
      </BootstrapTable>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/ReceivePaymentBody.js